import { render, staticRenderFns } from "./DelMenuCatalog.vue?vue&type=template&id=3f067720&scoped=true"
import script from "./DelMenuCatalog.vue?vue&type=script&lang=js"
export * from "./DelMenuCatalog.vue?vue&type=script&lang=js"
import style0 from "./DelMenuCatalog.vue?vue&type=style&index=0&id=3f067720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f067720",
  null
  
)

export default component.exports